import React from "react"
import { currencies, defaultCurrency } from "../data/currencies"

const SiteContext = React.createContext({
  locale: "en",
  currency: defaultCurrency,
  setCurrency: () => {},
  dir: "ltr",
  formatPrice: () => "",
})

export function SiteProvider({ children }) {
  const [currency, setCurrencyState] = React.useState(defaultCurrency)

  React.useEffect(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("livetutor-currency") : null
    if (saved && currencies[saved]) {
      setCurrencyState(saved)
    }
  }, [])

  const setCurrency = (code) => {
    setCurrencyState(code)
    if (typeof window !== "undefined") {
      localStorage.setItem("livetutor-currency", code)
    }
  }

  const formatPrice = (usdMin, usdMax) => {
    const curr = currencies[currency]
    const min = Math.round(usdMin * curr.rate)
    const max = Math.round(usdMax * curr.rate)
    if (usdMin === usdMax) {
      return `${curr.symbol}${min}`
    }
    return `${curr.symbol}${min} - ${curr.symbol}${max} / hr`
  }

  const value = {
    locale: "en",
    currency,
    setCurrency,
    dir: "ltr",
    formatPrice,
    currencies,
  }

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>
}

export function useSite() {
  return React.useContext(SiteContext)
}

export default SiteContext
